var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "ensemble-filter search-input cols" },
        [_c("ensemble-search", { on: { triggerSearch: _vm.searchTerm } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "ensemble-filter dropdown-input cols" }, [
        _c(
          "button",
          {
            attrs: {
              type: "button",
              "data-toggle": "dropdown",
              "aria-haspopup": "true",
              "aria-expanded": "true",
            },
          },
          [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.selectedValue) +
                "\n                    "
            ),
            _c("img", {
              staticClass: "arrow-down-icon svg",
              attrs: {
                src: "/app/themes/ucla/resources/assets/images/chevron.svg",
                width: "16px",
                height: "16px",
                alt: "dropdown",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "sr-only" }, [_vm._v("Dropdown")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "dropdown-menu" },
          [
            _c("li", { staticClass: "active" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.resetCategory()
                    },
                  },
                },
                [_vm._v("All")]
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.categories, function (item, index) {
              return _c("ensemble-category", {
                key: index,
                attrs: { item: item },
                on: { chooseCategory: _vm.onChooseCategory },
              })
            }),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c(
            "transition-group",
            {
              staticClass: "row grid-card-row",
              attrs: { name: "fade", tag: "div" },
            },
            _vm._l(_vm.items, function (item, index) {
              return _c("ensemble-card", { key: index, attrs: { item: item } })
            }),
            1
          ),
          _vm._v(" "),
          _vm.loading
            ? _c("div", { staticClass: "loader" }, [
                _vm._v("Loading Ensembles..."),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { attrs: { id: "ensemble-list-bottom" } }, [
            _vm.noMoreItems ? _c("div") : _vm._e(),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/EnsemblesDirectory.vue